export enum PrinterCut {
  OFF = "OFF",
  HALF = "HALF",
  FULL = "FULL",
}
